import { Injectable } from '@angular/core'
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { isDevMode } from '@angular/core'
import 'rxjs/add/observable/throw';

// Operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import luaScript from '../model/mock-data'
import { ConfigService } from '.';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var DFK: any;

@Injectable()
export class HttpService {

	content: string;
	current_url = 'http://';
	proxy = '';
	fetch_url: string;
	parse_url: string;
	baseUrl: string;
	createTaskURL: string;
	cancelRequest: string;
	billingCreditsRequest: string;

	constructor(private _http: HttpClient, private configService: ConfigService) {
		if (isDevMode()) {
			this.fetch_url = 'http://localhost:8082/fetch';
			this.parse_url = 'http://localhost:8082/parse';
			this.cancelRequest = 'http://localhost:8082/cancel/';
			this.createTaskURL = 'http://localhost:8082/v1/task/create?api_key=';
			this.billingCreditsRequest = 'http://localhost:8082/v1/credits?api_key=';
		} else {
			this.createTaskURL = 'https://api.dataflowkit.com/v1/task/create?api_key=';
			this.fetch_url = 'https://api.dataflowkit.com/fetch';
			this.parse_url = 'https://api.dataflowkit.com/parse';
			this.cancelRequest = 'https://api.dataflowkit.com/cancel/';
			this.billingCreditsRequest = 'https://api.dataflowkit.com/v1/credits?api_key=';
			/* this.fetch_url = 'http://134.209.92.232:8000/fetch';
			this.parse_url = 'http://134.209.92.232:8001/parse';
			this.cancelRequest = 'http://134.209.92.232:8082/process/'; */
		}
	}

	load(url: string, post_params = '', action = null) {
		// return this.http.get('app/import.html').map(res=>res.text());
		let actions = new Array<any>();
		// actions.push({'paginate': {'maxpage': 10, 'element': ''}})
		if (action !== null) {
			actions.push(action)
		}
		actions.push({ 'initsg': {} });
		if (url === '') {
			url = this.current_url;
		}
		let json = JSON.stringify({
			'url': url,
			'formData': post_params,
			'userToken': this.configService.userToken,
			'type': 'chrome',
			'initSelectorGadget': true,
			'proxy': (this.proxy !== undefined && this.proxy.length > 0) ? this.proxy : '',
			'waitDelay': 1.5,
			'actions': actions
		});
		let headers = new HttpHeaders();
		if (post_params !== '') {
			headers.set('Content-Type', 'multipart/form-data');
		} else {
			headers.set('Content-Type', 'application/json');
		}
		// this.current_url = url;

		return this._http.post(this.fetch_url, json,
			{
				observe: 'response',
				headers: headers,
				responseType: 'text'
			})/* .map(res => res.json()) */;
	}

	get(url: string): Observable<string> {
		return this._http.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	postCollection(collection: string) {
		let params = collection;
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		return this._http.post(this.parse_url, params,
			{
				'headers': headers
			})/* .map(res => res.text()) */;
	}

	sendCancelRequest(processID: string) {
		return this._http.get(this.cancelRequest + processID);
	}

	private extractData(res: Response) {
		let body = res.text();
		if (body !== '') {
			console.log('Response is not empty!');
		}
		return body;
	}

	createTask(task: string) {
		let hdrs = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.post(this.createTaskURL + DFK.User.APIKey, task, { headers: hdrs });
	}

	getUserCredits(APIKey: string) {
		return this._http.get(this.billingCreditsRequest + APIKey);
	}

	private handleError(error: Response | any) {
		let errMsg: string;
		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}
		console.error(errMsg);
		return Observable.throw(errMsg);
	}
}
